import React from 'react'
import { connect } from 'react-redux'
import { showNotification, UPDATE } from 'react-admin'

import { Typography, CircularProgress, Button, Grid, Collapse, FormGroup, FormControlLabel, Switch, TextField } from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import dataProvider from '../../../../../providers'
import { getResource } from '../../../../../config/resources'

class TransfersConfig extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openList: false,
      homestate: null,
      fetching: false,
    }
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({ homestate: this.props.data })
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data && this.props.data !== prevProps.data) {
      this.setState({ homestate: this.props.data })
    }
  }

  handleClick = () => {
    this.setState({
      openList: !this.state.openList,
    })
  }

  handleTransfersConfig(event, section) {
    const copyHomeState = { ...this.state.homestate }
    if (section === 'isRestricted') {
      copyHomeState.contentJson.isRestricted = event.target.checked
    } else if (section === 'rateDaily' || section === 'rateHourly' || section === 'rateMinutely' || section === 'rateUser') {
      copyHomeState.contentJson[section] = event.target.value === '' ? '' : Number(event.target.value)
    }

    this.setState({ homestate: copyHomeState })
  }

  handleSaveData() {
    this.setState({ fetching: true })
    let data = { ...this.state.homestate }
    data.contentJson = JSON.stringify(data.contentJson)
    dataProvider(UPDATE, getResource('transversal', 'globaldatas'), {
      id: this.state.homestate.id,
      data: data,
    })
      .then(({ data }) => {
        this.setState({ fetching: false, homestate: data })
        this.props.showNotification('Chatbot config state updated', 'success')
      })
      .catch((error) => {
        this.setState({ error: true, fetching: false })
        this.props.showNotification(error.message, 'error')
      })
  }

  render() {
    return (
      <>
        <div style={{ margin: '29px' }}>
          {this.props.loading ? (
            <div style={{ display: 'flex' }}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px', marginRight: '16px' }}>
                Loading Chatbot Config
              </Typography>
              <CircularProgress size={24} />
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'flex-start' }} onClick={() => this.handleClick()}>
              <Typography component="h2" variant="h2" style={{ marginBottom: '16px' }}>
                Chatbot Config
              </Typography>
              <div style={{ marginLeft: '16px' }}>{this.state.openList ? <ExpandLess /> : <ExpandMore />}</div>
            </div>
          )}
          {this.state.homestate && this.state.openList && (
            <Collapse in={this.state.openList} timeout={350}>
              <Grid item xs={12} lg={8}>
                <div style={{ opacity: this.props.loading ? 0 : 1, transition: 'opacity 350ms' }}>
                  <Grid item xs={12} lg={8}>
                    <Grid item xs={12}>
                      <FormGroup>
                        <FormControlLabel
                          label="Restricted"
                          control={
                            <Switch
                              checked={this.state.homestate?.contentJson?.isRestricted}
                              value={this.state.homestate?.contentJson?.isRestricted}
                              onChange={(event) => this.handleTransfersConfig(event, 'isRestricted')}
                              name="isRestricted"
                              color="primary"
                            />
                          }
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Rate Daily"
                        type="number"
                        name="rateDaily"
                        value={this.state.homestate?.contentJson?.rateDaily}
                        inputProps={{ min: 0 }}
                        onChange={(event) => this.handleTransfersConfig(event, 'rateDaily')}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Rate Hourly"
                        type="number"
                        name="rateHourly"
                        value={this.state.homestate?.contentJson?.rateHourly}
                        inputProps={{ min: 0 }}
                        onChange={(event) => this.handleTransfersConfig(event, 'rateHourly')}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Rate Minutely"
                        type="number"
                        name="rateMinutely"
                        value={this.state.homestate?.contentJson?.rateMinutely}
                        inputProps={{ min: 0 }}
                        onChange={(event) => this.handleTransfersConfig(event, 'rateMinutely')}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Rate User"
                        type="number"
                        name="rateUser"
                        value={this.state.homestate?.contentJson?.rateUser}
                        inputProps={{ min: 0 }}
                        onChange={(event) => this.handleTransfersConfig(event, 'rateUser')}
                      />
                    </Grid>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      disabled={this.props.loading || this.state.fetching}
                      onClick={() => this.handleSaveData()}
                    >
                      {this.state.fetching ? 'Saving...' : 'Save'}
                    </Button>
                  </Grid>
                </div>
              </Grid>
            </Collapse>
          )}
        </div>
      </>
    )
  }
}

const enhance = connect(null, {
  showNotification,
})

export default enhance(TransfersConfig)
